import React, { PropsWithChildren } from "react";
import GridItem from "./GridItem";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const GridItemTS: React.FC<PropsWithChildren<any>> = ({ children, ...props }) => {
  return <GridItem {...props}>{children}</GridItem>;
}

export default GridItemTS;
